// Shared chat image-preview logic (bot image click, preview dialog, image download,
// file-type icon lookup) extracted byte-identical from Stream.vue, FullStreamReDesign.vue,
// Snippet.vue and PlayGround.vue (SonarQube dedup). Behavior unchanged: each component
// implements getChatImageAuthToken() so the DownloadChatImage call keeps the exact
// token argument it had before (FullStreamReDesign/Snippet: auth_token_local; Stream/PlayGround: null).
import csvImg from "@/assets/images/FileTypes/csv.png";
import excelImg from "@/assets/images/FileTypes/excel.png";
import pdfImg from "@/assets/images/FileTypes/pdf.png";
import docImg from "@/assets/images/FileTypes/doc.png";
import plainImg from "@/assets/images/FileTypes/plain.png";
import pptImg from "@/assets/images/FileTypes/ppt.png";
import unknownImg from "@/assets/images/FileTypes/unknown.png";

export default {
  methods: {
    GetFileTypeImg(documentType) {
      switch (documentType) {
        case 1: return csvImg;
        case 2: return excelImg;
        case 3: return pdfImg;
        case 4: return docImg;
        case 5: return plainImg;
        case 6: return pptImg;
        default: return unknownImg;
      }
    },
    botMessageClick(e) {
      if (e?.target?.tagName === 'IMG') {
        this.dialogImage = e.target.src;
        this.showImage = true;
      }
    },
    downloadImage() {
      if (!this.dialogImage) return;
      this.alertDialog = true;
      this.closeDownloadDialog();
      this.$call.DownloadChatImage(
        this.dialogImage,
        this.getChatImageAuthToken(),
        async (dataResponse) => {
          const blob = new Blob([dataResponse], { type: "image/png" });
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = function () {
            const link = document.createElement("a");
            link.href = reader.result; // ใช้ Data URL
            link.download = "downloaded-image.png";
            document.body.appendChild(link);
            link.click();
            link.remove();
          };
          this.dialog_version = false;
          this.loading = false;
        },
        (errorResource) => {
          this.loading = false;
          this.isSearch = false;
          this.dialog_version = false;
          console.error(errorResource);
        }
      );
    },
    closeImage() {
      this.showImage = false;
      this.dialogImage = "";
    },
    closeDownloadDialog() {
      setTimeout(() => {
        this.alertDialog = false;
      }, 3000);
    },
  },
};
